import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import InfoIcon from '@material-ui/icons/Info';

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 'auto',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function ModalInfo(props) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      {      props.texto && props.texto != "" &&
        <p style={{color: '#000', fontWeight: 600}}>{props.texto}</p>
      }
      {props.imagem && props.imagem != "" &&
        <img src={props.imagem} alt="Image" />
      }
    </div>
  );

  return (
    <div style={{marginTop: 20}}>
        <label style={{color: '#000', fontWeight: 600}}>{props.label}</label>
        {((props.imagem && props.imagem != "") || props.texto && props.texto != "") &&
          <InfoIcon style={{cursor: "pointer", fontSize: '18px', marginLeft: '5px'}} onClick={handleOpen} />
        }
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
